/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

export const AIContext = React.createContext({});
